import { Text } from '@chakra-ui/react';
import {
    Notice, updateRequiredTypes, contactRequiredTypes, Property,
} from '@acp/shared';
import { ComponentProps } from 'react';
import { PopoverTag } from '../cards/action-tag';
import { UpdateLeaseDetailsLink } from './update-lease-details-link';
import { ActiveNoticesContactUs } from './active-notices-contact-us';
import { ResolveActionButton } from '../../../active-notice/components/buttons/resolve-action-button';
import { useActiveNotices } from '../../../active-notice/hooks/use-active-notices';

function ResolveIssueLink({
    property,
    notice,
    hideResolveButton = false,
    isContactDiRequired = false,
}: {
    property: Property;
    notice: Notice;
    hideResolveButton?: boolean;
    isContactDiRequired?: boolean;
}) {
    if (isContactDiRequired) {
        return <ActiveNoticesContactUs />;
    }

    if (hideResolveButton) {
        return true;
    }

    return <ResolveActionButton property={property} notice={notice} variant="underline-thin" hideDropDown />;
}

export function PortfolioActiveNoticesTag({
    popoverPlacement,
    property,
    address,
    notice,
    isIntegrated,
    useFullTagDescription = true,
    hideResolveButton = false,
}: {
    popoverPlacement: ComponentProps<typeof PopoverTag>['popoverPlacement'];
    property: Property;
    notice: Notice;
    address: string;
    isIntegrated: boolean;
    useFullTagDescription?: boolean;
    hideResolveButton?: boolean;
}) {
    const {
        activeNotice, activeNoticeDescription, noticeTypeDescription, action,
    } = useActiveNotices(
        notice,
        {
            propertyId: property.compliancePropertyId,
            address,
            isIntegrated,
        }
    );

    if (activeNotice === null) return null;

    return (
        <PopoverTag
            popoverPlacement={popoverPlacement}
            colorScheme="danger"
            title={
                useFullTagDescription
                    ? `Access issue (${noticeTypeDescription})`
                    : noticeTypeDescription
            }
        >
            <Text fontSize="small" fontWeight="bold" color="danger.500">
                {useFullTagDescription
                    ? `Access issue (${noticeTypeDescription})`
                    : noticeTypeDescription}
            </Text>
            <Text fontSize="small" mb={2}>
                We are experiencing difficulty gaining access to the property.
            </Text>
            {updateRequiredTypes.includes(activeNotice.noticeType) && (
                <>
                    <Text fontSize="small">{activeNoticeDescription}</Text>
                    <UpdateLeaseDetailsLink
                        property={property}
                        isContactDiRequired={activeNotice.isContactDiRequired}
                    />
                </>
            )}
            {contactRequiredTypes.includes(activeNotice.noticeType) && (
                <>
                    <Text fontSize="small">{activeNoticeDescription}</Text>
                    <Text fontSize="small" fontWeight="bold" mt={2}>
                        {action.description}
                    </Text>
                </>
            )}
            {updateRequiredTypes.includes(activeNotice.noticeType) === false
                && contactRequiredTypes.includes(activeNotice.noticeType) === false && (
                <>
                    <Text fontSize="small">{activeNoticeDescription}</Text>
                    <ResolveIssueLink
                        property={property}
                        notice={notice}
                        isContactDiRequired={activeNotice.isContactDiRequired}
                        hideResolveButton={hideResolveButton}
                    />
                </>
            )}
        </PopoverTag>
    );
}
